module.exports = __webpack_public_path__ + "img/background.1a267e96.svg";